@if (loading()) {
  <div class="loading">
    <lyceo-skeleton-text />
  </div>
  <div class="loading-line"></div>
} @else {
  @if (options().length > 1) {
    <div class="segments">
      @for (option of options(); track option.value) {
        <lyceo-segment-button
          [value]="option.value"
          (selected)="selectSegment($event)"
        >
          {{ option.label }}
        </lyceo-segment-button>
      }
    </div>
    <div class="line" #line></div>
  } @else if (options().length === 1) {
    <h3 class="h3">{{ firstLabel() }}</h3>
  }
}
